import { Component, OnDestroy, Inject, OnInit } from '@angular/core';
import {
  SuiModal,
  ComponentModalConfig,
  ModalSize,
  DatepickerMode,
} from '@richardlt/ng2-semantic-ui';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DOCUMENT } from '@angular/common';
import { Subject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AlertsService } from '../../services/alerts.service';
import { RateLimitService } from '../../services/rate-limit.service';
interface IUserDetailModalContext {
  data: any;
  title?: string;
}

@Component({
  selector: 'app-view-user-activity-modal',
  templateUrl: './view-user-activity-modal.component.html',
  styleUrls: ['./view-user-activity-modal.component.scss'],
})
export class ViewUserActivityModalComponent implements OnInit {
  success: any;
  error: any;
  user: any;
  pending = false;
  geofenceProfiles: any[] = [];
  rateLimitProfiles: any[] = [];
  constructor(
    public modal: SuiModal<IUserDetailModalContext, void, void>,
    private rateLimitSvc: RateLimitService
  ) {
    this.user = modal.context.data;
  }

  ngOnInit(): void {
    this.getUserActivity();
  }
  parseItem(item) {
    return JSON.parse(item);
  }

  getUserActivity() {
    this.pending = true;
    this.rateLimitSvc.getProfiles(this.user.user.appUserId).subscribe(
      (res: any) => {
        this.geofenceProfiles = res.geofenceProfiles;
        this.rateLimitProfiles = res.ratelimitProfiles;
        this.pending = false;
      },
      (error) => {
        this.pending = false;
      }
    );
  }
}

export class UserActivityModal extends ComponentModalConfig<
  IUserDetailModalContext,
  void,
  void
> {
  constructor(title: string, data: any, size: ModalSize = ModalSize.Small) {
    super(ViewUserActivityModalComponent, { title, data });

    this.isClosable = false;
    this.transitionDuration = 200;
    this.transition = 'slide left';
    this.size = size;
    this.isFullScreen = false;
    this.isInverted = false;
  }
}
